import { render, staticRenderFns } from "./ChangeOrganisationView.vue?vue&type=template&id=09a099bf&scoped=true"
import script from "./ChangeOrganisationView.vue?vue&type=script&lang=js"
export * from "./ChangeOrganisationView.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrganisationView.vue?vue&type=style&index=0&id=09a099bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a099bf",
  null
  
)

export default component.exports